const rejectionReasonType = Object.freeze({
  Unset: 0,
  DenegarAsignacion: 1,
  DenegarVinculo: 2,
  EliminarPeriodoFinalizado: 3,
  DeniedIncompleteReferral: 4,
  DenegarReferidoActivoRP: 6,
  DenegarVinculadoRP: 7,
  PlanDeAccion: 8,
});

export default rejectionReasonType;
